export const toCamelCase = (str: string): string =>
  str.replace(/-([a-z])/g, (_, c: string) => c.toUpperCase());

/** Formatta un numero con separatore migliaia italiano (punto). */
export function formatNumero(v: unknown): string {
  if (v === null || v === undefined) return '';
  const n = Number(v);
  if (isNaN(n)) return String(v);
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

/** "2025-11-29", "2025-11-29 00:00:00", "2025-11-29T00:00:00.000Z" → "29/11/2025" */
export function formatDate(v: string): string {
  if (!v) return '';
  const dateOnly = v.split(/[T ]/)[0]!;
  const [y, m, d] = dateOnly.split('-');
  return `${d}/${m}/${y}`;
}
